import styled from 'styled-components'

import { TransparentButton } from '../../../Common/Buttons'

export const UploadBoxContainer = styled.div`
  margin: 2rem 0;
  background-color: #f1f5f7;
  min-height: 120px;
  border: 0.125rem dashed #aebbc6;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
`

export const UploadButton = styled.button`
  color: ${(props) => props.theme.mainThemeColor};
  background: none;
  text-decoration: underline;
`

export const UploadFileInfo = styled.div`
  color: #5f6567;
  margin-top: 0.5rem;
`

export const ImageCard = styled.div`
  margin-top: 1rem;
  border: 0.125rem solid #eaeaea;
  border-radius: 5px;
  padding: 0.5rem;
`

export const StyledDeleteButton = styled(TransparentButton)`
  width: 100%;
  max-width: 30px;
`

export const ImageMetaInfo = styled.div`
  display: flex;
  align-items: center;
  grid-area: info;

  img {
    max-width: 69px;
    padding-right: 0.5rem;
  }
`
